import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { connect } from "react-redux";
import MoreInfoContent from "./MoreInfoContent";
import GWASContent from "./GWASContent";
import { getVarsoUrl } from "../../../../common/helpers/helpers";
import Modal from "../../../../components/atoms/Modal";
import {
  gwasListSelector,
  gwasLabelsSelector,
  gwasVariantVersionSelector,
} from "../../../../state/selectors/GWASComponent.selectors";
import withErrorGuard from "../../../../HOC/withErrorGuard";
import ComponentPanel from "../../../../components/atoms/ComponentPanel/ComponentPanel";
import HelperText from "../../../../components/atoms/HelperText";

function getGWASUrl(items) {
  const firstItem = (items || []).find((x) => x.gwas_symbol);
  const url = firstItem
    ? `https://www.ebi.ac.uk/gwas/search?query=${firstItem.gwas_symbol}`
    : null;
  return url ? getVarsoUrl(url) : null;
}

const Container = styled.div`
  margin-bottom: 1rem;
  border: 1px solid rgb(221, 221, 221);
`;

class GWAS extends React.Component {
  constructor() {
    super();
    this.state = { gwasPopupItem: null };
  }

  closeGwasModal = () => this.setState({ gwasPopupItem: null });

  openGwasModal = (item) => this.setState({ gwasPopupItem: item });

  render() {
    const componentTitle = "GWAS Catalog";
    const { gwasPopupItem } = this.state;
    const { labels, version, gwasList } = this.props;
    const url = getGWASUrl(gwasList);

    return gwasList.length ? (
      <Container>
        <div className="varsome-result">
          <div className="varsome-container varsome-container__basic">
            <ComponentPanel
              title={componentTitle}
              version={version}
              url={url}
              helperPopup={<HelperText fieldDescriptionKey={componentTitle} />}
              content={
                <React.Fragment>
                  <GWASContent
                    labels={labels}
                    gwasList={gwasList}
                    openGwasModal={this.openGwasModal}
                  />
                  <Modal
                    onRequestClose={this.closeGwasModal}
                    isOpen={Boolean(gwasPopupItem)}
                    ContentRender={() => (
                      <div className="tw-container tw-p-6">
                        <MoreInfoContent
                          result={gwasPopupItem}
                          labels={labels}
                        />
                      </div>
                    )}
                  />
                </React.Fragment>
              }
            />
          </div>
        </div>
      </Container>
    ) : null;
  }
}

GWAS.propTypes = {
  version: PropTypes.string,
  labels: PropTypes.shape({}),
  // eslint-disable-next-line react/forbid-prop-types
  gwasList: PropTypes.arrayOf(PropTypes.any),
};

GWAS.defaultProps = {
  labels: {},
  version: null,
  gwasList: [],
};

const mapStateToProps = (state) => ({
  labels: gwasLabelsSelector(state),
  version: gwasVariantVersionSelector(state),
  gwasList: gwasListSelector(state),
});

export default connect(
  mapStateToProps,
  {}
)(withErrorGuard(GWAS, "GWAS", "GWAS Catalog"));
